export default "__VITE_ASSET__XURP_hYe__"